import React from 'react';
import PropTypes from 'prop-types';

export const ImageAttachment = ({ image_url, fallback, onClick }) => {
  return (
    <div className="Attachment ImageAttachment">
      <img alt={fallback} src={image_url} onClick={onClick} />
    </div>
  );
};

ImageAttachment.propTypes = {
  image_url: PropTypes.string,
  fallback: PropTypes.string,
  onClick: PropTypes.func
};
